import classNames from "classnames";
import { WarningIcon, EquipmentIcon, EnergyIcon, ErrorIcon } from "components/atoms/Icon";

interface DataCoverageIconProps {
    identifier: DataCoverageEnum;
}

export function DataCoverageIcon({ identifier }: DataCoverageIconProps) {
    if (identifier.includes("error")) return <Error />;
    if (identifier.includes("no_equipment_and_no_utility")) return <NoEnergyAndEquipment />;
    if (identifier.includes("equipment_and_utility")) return <EnergyAndEquipment />;
    if (identifier.includes("processing")) return <Processing />;
    if (identifier.includes("utility")) return <Energy />;
    if (identifier.includes("equipment")) return <Equipment />;
}

export function WarningIconWithContainer() {
    return (
        <span className="status-tag">
            <WarningIcon />
        </span>
    );
}
function Processing() {
    return (
        <div className="status-tag">
            <ProcessingIcon />
        </div>
    );
}

export function Energy() {
    return (
        <div className="dataCoverageIconsContainer">
            <GreenEnergy />
            <div className={classNames("status-tag", "status-tag--grey-nobackground")}>
                <EquipmentIcon size="medium" />
            </div>
        </div>
    );
}

export function GreenEnergy() {
    return (
        <div className={classNames("status-tag", "status-tag--green")} style={{ marginRight: 0, paddingRight: 0 }}>
            <EnergyIcon size="medium" />
        </div>
    );
}

export function NoEnergyAndEquipment() {
    return (
        <div className={classNames("status-tag", "status-tag--grey-nobackground")}>
            <EnergyIcon size="medium" />
            <EquipmentIcon size="medium" />
        </div>
    );
}

export function EnergyAndEquipment() {
    return (
        <div className={classNames("status-tag", "status-tag--green")}>
            <EnergyIcon size="medium" />
            <EquipmentIcon size="medium" />
        </div>
    );
}

export function Equipment() {
    return (
        <div className="dataCoverageIconsContainer">
            <div
                className={classNames("status-tag", "status-tag--grey-nobackground")}
                style={{ marginRight: 0, paddingRight: 0 }}
            >
                <EnergyIcon size="medium" />
            </div>
            <GreenEquipment />
        </div>
    );
}

export function GreenEquipment() {
    return (
        <div className={classNames("status-tag", "status-tag--green")}>
            <EquipmentIcon size="medium" />
        </div>
    );
}

export function Error() {
    return (
        <div className="status-tag status-tag--negative">
            <ErrorIcon />
        </div>
    );
}

function ProcessingIcon() {
    return (
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9.71457 0.794922C13.5043 1.17149 16.5248 4.17599 16.8853 7.9817C17.326 12.3883 14.1212 16.2982 9.71457 16.7388V15.1364C12.6309 14.7919 14.9224 12.4764 15.2909 9.56007C15.7236 6.04279 13.2318 2.846 9.71457 2.41335V0.810946V0.794922ZM8.11216 0.818958V2.42136C6.96644 2.5816 5.88482 3.0463 4.98748 3.76738L3.84176 2.5816C5.05958 1.57209 6.54982 0.971186 8.11216 0.818958ZM2.71206 3.7113L3.85778 4.85701C3.14471 5.76237 2.69604 6.844 2.54381 7.9817H0.941406C1.10165 6.41135 1.70255 4.92912 2.71206 3.7113ZM0.949418 9.58411H2.55182C2.69604 10.7218 3.15272 11.8034 3.85778 12.7088L2.72007 13.8545C1.72658 12.6367 1.10966 11.1545 0.949418 9.58411ZM4.98748 13.8866C5.89283 14.5916 6.97446 15.0483 8.11216 15.1925V16.7949C6.54181 16.6267 5.05157 15.9937 3.84176 14.9842L4.98748 13.8866ZM8.91336 12.3883L5.30796 8.7829H8.11216V5.5781H9.71457V8.7829H12.5188L8.91336 12.3883Z"
                fill="#757575"
            />
        </svg>
    );
}
